export const dateFormat = (dateString: string) => {
  const date = new Date(dateString);
  return date.toISOString().split('T')[0];
};

export const getTime = (dateString: string) => {
  return dateString.split('T')[1].split('.')[0];
};

